import * as confirmationActions from '../actions/confirmation.action';

export interface State {
  userName: string;
  idNumber: string;
  arrivalDate: any;
  departureDate: any;
  error: any;
}

export const initialState: State = {
  userName: '',
  idNumber: '',
  arrivalDate: '',
  departureDate: '',
  error: null
};

export function reducer(
  state = initialState,
  action: confirmationActions.confirmationAction
) {
  switch (action.type) {
    case confirmationActions.VIEW_ACCOMMODATION_CONFIRMATION_SUCCESS:
    case confirmationActions.VIEW_CONFERENCE_CONFIRMATION_SUCCESS: {
      const booker = action.payload;
      return {
        ...state,
        userId: booker.id,
        title: booker.title,
        userName: `${booker.lastName}, ${booker.firstNames}`,
        idNumber: booker.idNumber,
        arrivalDate: booker.arrivalDate,
        departureDate: booker.departureDate
      };
    }
    case confirmationActions.VIEW_ACCOMMODATION_CONFIRMATION_FAIL:
    case confirmationActions.VIEW_CONFERENCE_CONFIRMATION_FAIL: {
      const error = action.payload;
      return {
        ...state,
        error
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/store/reducers/confirmation.reducer.ts